import React from 'react';

/**
 * Chip — THE status/priority pill (DT Alpha surfaces). One visual form for
 * every colored badge: ticket status/priority, device status, origins.
 *
 * Color convention: a 13% tint of the color as the background + the solid color for the text
 * and the dot. The tint is built with color-mix() so it works for BOTH kinds of color callers
 * pass — a hex ('#2f9e6e') and a token ('var(--dt-bad)'). The old `${color}22` suffix only
 * worked for a hex: for a var() it produced an invalid value, so an Overdue chip drew no tint
 * at all. 13% is the old 0x22 alpha (34/255), so hex chips look exactly as before.
 */
export const chipTint = (color: string): string => `color-mix(in srgb, ${color} 13%, transparent)`;

const Chip: React.FC<{ text: string; color: string }> = ({ text, color }) => (
  <span className="dt-chip" style={{ background: chipTint(color), color }}>
    <span className="cd" style={{ background: color }} />
    {text}
  </span>
);

export default Chip;
